import { Grid } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import QuickNavigation from "../../common/quick-navigation";

export default function AirframeTemplateUploadCard() {
  return (
    <Grid size={{ xs: 12, lg: 4 }} sx={{ minWidth: 350 }}>
      <QuickNavigation
        icon={<CloudUploadIcon sx={{ fontSize: 24 }} />}
        actions={[
          {
            label: "Bulk Template Upload",
            route: "/assets/bulk-template-upload",
          },
        ]}
        title="Bulk Template Upload"
        description="Upload JSON templates and download Excel import sheets."
      />
    </Grid>
  );
}